// The confirm gate's open state lives in the URL, not component state, because
// `.agents/rules/url-state.mdc` rule 3 requires layered UI state to be a query param.
// It is the `dialog` slot rather than `sheet` because `overlay.ts:39-47` layers `dialog`
// over `sheet`, and the revive sheet has to be able to sit on top of this gate.

export const CONTEST_CONFIRM_DIALOG_NAME = "contest-confirm";

export function isContestConfirmGateOpen(search: {
  dialog?: string | undefined;
}): boolean {
  return search.dialog === CONTEST_CONFIRM_DIALOG_NAME;
}

export function openContestConfirmGateSearch<
  TSearch extends Record<string, unknown>,
>(search: TSearch): TSearch & { dialog: typeof CONTEST_CONFIRM_DIALOG_NAME } {
  return { ...search, dialog: CONTEST_CONFIRM_DIALOG_NAME };
}

export function closeContestConfirmGateSearch<
  TSearch extends Record<string, unknown>,
>(search: TSearch): TSearch {
  return Object.fromEntries(
    Object.entries(search).filter(([key]) => key !== "dialog"),
  ) as TSearch;
}
